module.exports = __webpack_public_path__ + "static/media/loophole.aa64ff07.gif";